import {gql} from "@apollo/client";

export const DELETE_SORTER = gql`
    mutation DeleteSorter($id: Long!) {
        deleteSorter(id: $id)
    }
`;

export interface DeleteSorterResponse {
    deleteSorter: boolean;
}

export interface DeleteSorterVariables {
    id: number;
}

